import { useState } from 'react';
import { testimonials } from '../../../mocks/testimonials';

export default function TestimonialSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentTestimonial = testimonials[currentIndex];

  const nextTestimonial = () => setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  const prevTestimonial = () => setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="py-16 sm:py-24 px-4 relative">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-14">
          <p className="text-primary-gold text-xs sm:text-sm tracking-[0.3em] uppercase font-semibold mb-3">
            실제 이용자 후기
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white">
            운명을 바꾼 경험들
          </h2>
        </div>

        <div className="relative bg-primary-dark/80 backdrop-blur-sm rounded-2xl sm:rounded-3xl overflow-hidden border border-primary-gold/30 p-6 sm:p-8 md:p-12">
          <div className="absolute top-4 left-6 text-primary-gold/15 text-7xl sm:text-9xl font-serif leading-none select-none">"</div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-7 sm:gap-10 items-start relative z-10">
            {/* Profile */}
            <div className="flex flex-col items-center md:items-start gap-4">
              {/* Image */}
              <div className="relative">
                <div className="w-28 h-28 sm:w-36 sm:h-36 md:w-44 md:h-44 rounded-2xl border-2 border-primary-gold/50 overflow-hidden">
                  <img
                    src={currentTestimonial.image}
                    alt={currentTestimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute -bottom-2 -right-2 w-9 h-9 sm:w-11 sm:h-11 bg-gold-gradient rounded-full flex items-center justify-center border-4 border-primary-dark">
                  <i className="ri-star-fill text-primary-dark text-sm sm:text-lg"></i>
                </div>
              </div>

              {/* Name & Info */}
              <div className="text-center md:text-left">
                <p className="text-white font-bold text-base sm:text-lg">{currentTestimonial.name}</p>
                <p className="text-mystic-purple text-xs sm:text-sm mt-0.5">{currentTestimonial.occupation}</p>
                <p className="text-purple-400/60 text-xs mt-1">
                  <i className="ri-time-line mr-1"></i>
                  {currentTestimonial.date} 이용
                </p>
              </div>

              {/* Stars */}
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <i
                    key={i}
                    className={`text-base sm:text-lg ${
                      i < currentTestimonial.rating
                        ? 'ri-star-fill text-primary-gold'
                        : 'ri-star-line text-primary-gold/30'
                    }`}
                  ></i>
                ))}
                <span className="ml-2 text-primary-gold text-sm font-bold">{currentTestimonial.rating}.0</span>
              </div>
            </div>

            {/* Content */}
            <div className="md:col-span-2 flex flex-col justify-between gap-5">
              {/* Highlight Badge */}
              {currentTestimonial.highlight && (
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-gold/15 border border-primary-gold/30 w-fit">
                  <i className="ri-check-double-line text-primary-gold text-sm"></i>
                  <span className="text-primary-gold text-xs sm:text-sm font-semibold">{currentTestimonial.highlight}</span>
                </div>
              )}

              <p className="text-white/90 text-sm sm:text-base md:text-lg leading-relaxed">
                {currentTestimonial.content}
              </p>

              {/* Navigation */}
              <div className="flex items-center justify-between mt-2">
                <div className="flex items-center gap-3">
                  <button
                    onClick={prevTestimonial}
                    className="w-9 h-9 sm:w-10 sm:h-10 rounded-full border-2 border-primary-gold text-primary-gold hover:bg-primary-gold hover:text-primary-dark transition-all flex items-center justify-center cursor-pointer"
                  >
                    <i className="ri-arrow-left-s-line text-lg sm:text-xl"></i>
                  </button>
                  <button
                    onClick={nextTestimonial}
                    className="w-9 h-9 sm:w-10 sm:h-10 rounded-full border-2 border-primary-gold text-primary-gold hover:bg-primary-gold hover:text-primary-dark transition-all flex items-center justify-center cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line text-lg sm:text-xl"></i>
                  </button>
                  <div className="flex gap-2 ml-2">
                    {testimonials.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentIndex(index)}
                        className={`h-2 rounded-full transition-all cursor-pointer ${
                          index === currentIndex ? 'bg-primary-gold w-6 sm:w-8' : 'bg-primary-gold/30 w-2'
                        }`}
                      />
                    ))}
                  </div>
                </div>

                <span className="text-purple-400/60 text-xs tabular-nums">
                  {currentIndex + 1} / {testimonials.length}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
